import { Component, OnInit, ViewChild, Input,ViewChildren ,ElementRef} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CustomConfirmDialogService } from 'src/app/services/Non-Master/CustomConfirmDialog.service';
import { LoggerService } from 'src/app/services/Non-Master/logger.service';
import { tItemService } from 'src/app/services/tItem.service';
import { MatTableDataSource, MatPaginator } from '@angular/material';
import { tItemModel, tItemModelwithCateInfo } from 'src/app/models/tItemModel';
import { MastersKeyStringValue } from 'src/app/services/Non-Master/MastersKeyStringValue.service';
import { AppSettings } from 'src/app/shared/AppSettings';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SystemDefaultModel, ChineseDefaultModel, EnglishDefaultModel } from 'src/app/models/non-master-model/SystemDefaultModel';
import { AppComponent } from 'src/app/app.component';
import { FormControl } from '@angular/forms';
import { SearchItemIDDialogService } from 'src/app/services/Non-Master/SearchItemIDDialog.service';
import { NavigationComponent } from 'src/app/pages/navigation/navigation.component';
import { preDefineCate } from 'src/app/models/tItemCateModel';
import { UnitItemService } from 'src/app/services/Unit/UnitItem.service';
import { UnitItemModel } from 'src/app/models/UnitItemModel';

@Component({
  selector: 'app-search-item-id-dialog',
  templateUrl: './search-item-id-dialog.component.html',
  styleUrls: ['./search-item-id-dialog.component.css']
})
export class SearchItemIdDialogComponent implements OnInit {

  selectedRowIndex = -1;

  itemUnitList:UnitItemModel[];
  @ViewChild("searchInput") private searchInputElement: ElementRef;

  setFocus() {

      this.searchInputElement.nativeElement.focus();

  }

  constructor(
    public activeModal: NgbActiveModal,
    private router: Router,
    private customConfirmDialogService: CustomConfirmDialogService,
    private log: LoggerService,
    private route: ActivatedRoute,
    private tItemService: tItemService,
    private el: ElementRef,
    private unitItemService : UnitItemService,
    ) { }

  displayedColumns: string[] = [
    // 'action_button_title',

    // 'shopID',

    'itemID',
    // 'itemSeq',

    //'itemCateName',
    'itemDescAll',
    // 'itemDesc',
    // 'itemDescEng',

    // 'itemDescMobile',

    // 'itemCateID',
    // 'itemCostMethod',

    // 'itemUnit',

    // 'itemSysCost',
    'standardPrice',
    // 'itemNeedTime',
    // 'itemRemark1',
    // 'itemRemark2',
    // 'itemRemark3',

    // 'lastModifyDatetime',
    // 'lastModifyUserID',
    // 'isActive'

  ];

  dataSource: MatTableDataSource<tItemModelwithCateInfo>;
  dataList: tItemModelwithCateInfo[];
  itemDescFilter = new FormControl();
  itemCateNameFilter = new FormControl();

  itemIDFilter = new FormControl();


  filteredValues = {
    itemDesc: '', itemDescEng: '', itemCateName: '', itemID: ''
  };




  @ViewChild(MatPaginator) paginator: MatPaginator;

  TAG = 'SearchItemIdDialogComponent';
  // displayMsg: string;
  @Input() action: string;
  @Input() status: string;
  @Input() tableKeyValue: string;
  @Input() msg: string;
  // adding for booking search service only
  @Input() searchFilter: number;

  ngOnInit() {
    this.setDefaultLanguageString(AppComponent.usingLanguage);

    this.getAllData();


    setTimeout(() => {
      this.setFocus();
    }, 100);
  }

  getAllData(): void {
    this.log.i(this.TAG, 'getAllData searchFilter = ' + this.searchFilter);
    // this.getItemTypeInfo();

    const SerivceOnly = 1;
    const StockItemOnly = 2;
    const ItemAndService = 3;
    const NonDiagonsisServiceOnly = 4;
    const PrescriptionB01ItemOnly = 901;
    const PrescriptionB02ItemOnly = 902;
    const PrescriptionB03ItemOnly = 903;
    const PrescriptionD97ItemOnly = 911;
    const only30=5;
    // 1 = service only
    if (this.searchFilter === SerivceOnly) {
      // isService
      this.tItemService.getAllDataWithItemCateInfo_isServiceOnly(NavigationComponent.selectedShopID).subscribe(data => {

        data = data.filter(x => x.shopID === NavigationComponent.selectedShopID.toString());

        this.dataList = data;
        this.dataSource = new MatTableDataSource<tItemModelwithCateInfo>(this.dataList);
        this.dataSource.paginator = this.paginator;

        this.itemDescFilter.valueChanges.subscribe((itemDescFilterValue) => {
          this.filteredValues['itemDesc'] = itemDescFilterValue;
          this.filteredValues['itemDescEng'] = itemDescFilterValue;
          this.dataSource.filter = JSON.stringify(this.filteredValues);
        });

        this.itemCateNameFilter.valueChanges.subscribe((ItemCateIDFilterValue) => {
          this.filteredValues['itemCateName'] = ItemCateIDFilterValue;
          this.dataSource.filter = JSON.stringify(this.filteredValues);
        });

        this.itemIDFilter.valueChanges.subscribe((value) => {
          this.filteredValues['itemID'] = value;
          this.dataSource.filter = JSON.stringify(this.filteredValues);
        });

        this.dataSource.filterPredicate = this.customFilterPredicate();

      });

    } else if (this.searchFilter === StockItemOnly) {
      this.tItemService.getAllDataWithItemCateInfo_isStockItemOnly(NavigationComponent.selectedShopID).subscribe(data => {

        data = data.filter(x => x.shopID === NavigationComponent.selectedShopID.toString()
        && x.itemCateID !== 'b01'
        && x.itemCateID !== 'b02'
        && x.itemCateID !== 'b03' && x.inActive == 'N');

        this.dataList = data;
        this.dataSource = new MatTableDataSource<tItemModelwithCateInfo>(this.dataList);
        this.dataSource.paginator = this.paginator;

        this.itemDescFilter.valueChanges.subscribe((itemDescFilterValue) => {
          this.filteredValues['itemDesc'] = itemDescFilterValue;
          this.filteredValues['itemDescEng'] = itemDescFilterValue;
          this.dataSource.filter = JSON.stringify(this.filteredValues);
        });

        this.itemCateNameFilter.valueChanges.subscribe((ItemCateIDFilterValue) => {
          this.filteredValues['itemCateName'] = ItemCateIDFilterValue;
          this.dataSource.filter = JSON.stringify(this.filteredValues);
        });

        this.itemIDFilter.valueChanges.subscribe((value) => {
          this.filteredValues['itemID'] = value;
          this.dataSource.filter = JSON.stringify(this.filteredValues);
        });

        this.dataSource.filterPredicate = this.customFilterPredicate();

      });
    } else if (this.searchFilter === ItemAndService) {
      // All item & service
      this.tItemService.getAllDataWithItemCateInfo(NavigationComponent.selectedShopID).subscribe(data => {

        data = data.filter(x => x.shopID === NavigationComponent.selectedShopID.toString());

        this.dataList = data;
        this.dataSource = new MatTableDataSource<tItemModelwithCateInfo>(this.dataList);
        this.dataSource.paginator = this.paginator;


        this.itemDescFilter.valueChanges.subscribe((itemDescFilterValue) => {
          this.filteredValues['itemDesc'] = itemDescFilterValue;
          this.filteredValues['itemDescEng'] = itemDescFilterValue;
          this.dataSource.filter = JSON.stringify(this.filteredValues);
        });

        this.itemCateNameFilter.valueChanges.subscribe((ItemCateNameFilterValue) => {
          this.filteredValues['itemCateName'] = ItemCateNameFilterValue;
          this.dataSource.filter = JSON.stringify(this.filteredValues);
        });

        this.itemIDFilter.valueChanges.subscribe((value) => {
          this.filteredValues['itemID'] = value;
          this.dataSource.filter = JSON.stringify(this.filteredValues);
        });

        this.dataSource.filterPredicate = this.customFilterPredicate();

      });
    } else if (this.searchFilter === NonDiagonsisServiceOnly) { // 4 = non diagonsis service only
      this.tItemService.getAllDataWithItemCateInfo_isServiceOnly_nonDiagonsis(NavigationComponent.selectedShopID, '').subscribe(data => {

        data = data.filter(x => x.shopID === NavigationComponent.selectedShopID.toString());

        this.dataList = data;
        this.dataSource = new MatTableDataSource<tItemModelwithCateInfo>(this.dataList);
        this.dataSource.paginator = this.paginator;


        this.itemDescFilter.valueChanges.subscribe((itemDescFilterValue) => {
          this.filteredValues['itemDesc'] = itemDescFilterValue;
          this.filteredValues['itemDescEng'] = itemDescFilterValue;
          this.dataSource.filter = JSON.stringify(this.filteredValues);
        });

        this.itemCateNameFilter.valueChanges.subscribe((ItemCateNameFilterValue) => {
          this.filteredValues['itemCateName'] = ItemCateNameFilterValue;
          this.dataSource.filter = JSON.stringify(this.filteredValues);
        });

        this.itemIDFilter.valueChanges.subscribe((value) => {
          this.filteredValues['itemID'] = value;
          this.dataSource.filter = JSON.stringify(this.filteredValues);
        });


        this.dataSource.filterPredicate = this.customFilterPredicate();

      });


    } else if (this.searchFilter === PrescriptionB01ItemOnly) {
      // Pres Item
      this.tItemService.getAllDataWithItemCateInfo(NavigationComponent.selectedShopID).subscribe(data => {

        data = data.filter(x => x.shopID === NavigationComponent.selectedShopID.toString());
        data = data.filter(x => x.itemCateID === preDefineCate.herf);

        this.dataList = data;
        this.dataSource = new MatTableDataSource<tItemModelwithCateInfo>(this.dataList);
        this.dataSource.paginator = this.paginator;


        this.itemDescFilter.valueChanges.subscribe((itemDescFilterValue) => {
          this.filteredValues['itemDesc'] = itemDescFilterValue;
          this.filteredValues['itemDescEng'] = itemDescFilterValue;
          this.dataSource.filter = JSON.stringify(this.filteredValues);
        });

        this.itemCateNameFilter.valueChanges.subscribe((ItemCateIDFilterValue) => {
          this.filteredValues['itemCateName'] = ItemCateIDFilterValue;
          this.dataSource.filter = JSON.stringify(this.filteredValues);
        });

        this.itemIDFilter.valueChanges.subscribe((value) => {
          this.filteredValues['itemID'] = value;
          this.dataSource.filter = JSON.stringify(this.filteredValues);
        });


        this.dataSource.filterPredicate = this.customFilterPredicate();

      });
    } else if (this.searchFilter === PrescriptionB02ItemOnly) {
      // Pres Item
      this.tItemService.getAllDataWithItemCateInfo(NavigationComponent.selectedShopID).subscribe(data => {

        data = data.filter(x => x.shopID === NavigationComponent.selectedShopID.toString());
        data = data.filter(x => x.itemCateID === preDefineCate.pill);

        this.dataList = data;
        this.dataSource = new MatTableDataSource<tItemModelwithCateInfo>(this.dataList);
        this.dataSource.paginator = this.paginator;


        this.itemDescFilter.valueChanges.subscribe((itemDescFilterValue) => {
          this.filteredValues['itemDesc'] = itemDescFilterValue;
          this.filteredValues['itemDescEng'] = itemDescFilterValue;
          this.dataSource.filter = JSON.stringify(this.filteredValues);
        });

        this.itemCateNameFilter.valueChanges.subscribe((ItemCateIDFilterValue) => {
          this.filteredValues['itemCateName'] = ItemCateIDFilterValue;
          this.dataSource.filter = JSON.stringify(this.filteredValues);
        });

        this.itemIDFilter.valueChanges.subscribe((value) => {
          this.filteredValues['itemID'] = value;
          this.dataSource.filter = JSON.stringify(this.filteredValues);
        });


        this.dataSource.filterPredicate = this.customFilterPredicate();

      });
    } else if (this.searchFilter === PrescriptionB03ItemOnly) {
      // Pres Item
      this.tItemService.getAllDataWithItemCateInfo(NavigationComponent.selectedShopID).subscribe(data => {

        data = data.filter(x => x.shopID === NavigationComponent.selectedShopID.toString());
        data = data.filter(x => x.itemCateID === preDefineCate.concPowder);

        this.dataList = data;
        this.dataSource = new MatTableDataSource<tItemModelwithCateInfo>(this.dataList);
        this.dataSource.paginator = this.paginator;


        this.itemDescFilter.valueChanges.subscribe((itemDescFilterValue) => {
          this.filteredValues['itemDesc'] = itemDescFilterValue;
          this.filteredValues['itemDescEng'] = itemDescFilterValue;
          this.dataSource.filter = JSON.stringify(this.filteredValues);
        });

        this.itemCateNameFilter.valueChanges.subscribe((ItemCateIDFilterValue) => {
          this.filteredValues['itemCateName'] = ItemCateIDFilterValue;
          this.dataSource.filter = JSON.stringify(this.filteredValues);
        });

        this.itemIDFilter.valueChanges.subscribe((value) => {
          this.filteredValues['itemID'] = value;
          this.dataSource.filter = JSON.stringify(this.filteredValues);
        });


        this.dataSource.filterPredicate = this.customFilterPredicate();

      });
    } else if (this.searchFilter === PrescriptionD97ItemOnly) {
      // Pres Item
      this.tItemService.getAllDataWithItemCateInfo(NavigationComponent.selectedShopID).subscribe(data => {

        data = data.filter(x => x.shopID === NavigationComponent.selectedShopID.toString());
        data = data.filter(x => x.itemCateID === preDefineCate.other_fee);

        this.dataList = data;
        this.dataSource = new MatTableDataSource<tItemModelwithCateInfo>(this.dataList);
        this.dataSource.paginator = this.paginator;


        this.itemDescFilter.valueChanges.subscribe((itemDescFilterValue) => {
          this.filteredValues['itemDesc'] = itemDescFilterValue;
          this.filteredValues['itemDescEng'] = itemDescFilterValue;
          this.dataSource.filter = JSON.stringify(this.filteredValues);
        });

        this.itemCateNameFilter.valueChanges.subscribe((ItemCateIDFilterValue) => {
          this.filteredValues['itemCateName'] = ItemCateIDFilterValue;
          this.dataSource.filter = JSON.stringify(this.filteredValues);
        });

        this.itemIDFilter.valueChanges.subscribe((value) => {
          this.filteredValues['itemID'] = value;
          this.dataSource.filter = JSON.stringify(this.filteredValues);
        });


        this.dataSource.filterPredicate = this.customFilterPredicate();

      });
    }else if (this.searchFilter === only30) {
      this.tItemService.getAllDataWithItemCateInfo(NavigationComponent.selectedShopID).subscribe(data => {

        data = data.filter(x => x.shopID === NavigationComponent.selectedShopID.toString()
        && x.itemCateID == '30'&& x.inActive == 'N');

        this.dataList = data;
        this.dataSource = new MatTableDataSource<tItemModelwithCateInfo>(this.dataList);
        this.dataSource.paginator = this.paginator;

        this.itemDescFilter.valueChanges.subscribe((itemDescFilterValue) => {
          this.filteredValues['itemDesc'] = itemDescFilterValue;
          this.filteredValues['itemDescEng'] = itemDescFilterValue;
          this.dataSource.filter = JSON.stringify(this.filteredValues);
        });

        this.itemCateNameFilter.valueChanges.subscribe((ItemCateIDFilterValue) => {
          this.filteredValues['itemCateName'] = ItemCateIDFilterValue;
          this.dataSource.filter = JSON.stringify(this.filteredValues);
        });

        this.itemIDFilter.valueChanges.subscribe((value) => {
          this.filteredValues['itemID'] = value;
          this.dataSource.filter = JSON.stringify(this.filteredValues);
        });

        this.dataSource.filterPredicate = this.customFilterPredicate();

      });
    }




  }

  customFilterPredicate() {
    const myFilterPredicate = (data: tItemModelwithCateInfo, filter: string): boolean => {

      const searchString = JSON.parse(filter);

      return ((searchString.itemDesc.toLowerCase() === '' ||
        (data.itemDesc != null && data.itemDesc.toString().trim().toLowerCase().startsWith(searchString.itemDesc.toLowerCase().trim())))
        ||
        (searchString.itemDescEng.toLowerCase() === '' ||
          (data.itemDescEng != null && data.itemDescEng.toString().trim().toLowerCase().indexOf(searchString.itemDescEng.toLowerCase().trim()) !== -1))
        )
        &&
        (searchString.itemCateName.toLowerCase() === '' ||
          (data.itemCateName != null && data.itemCateName.toString().toLowerCase().trim().startsWith(searchString.itemCateName.toLowerCase().trim())))
        &&
        (searchString.itemID.toLowerCase() === '' ||
          (data.itemID != null && data.itemID.toString().trim().toLowerCase().indexOf(searchString.itemID.toLowerCase().trim()) !== -1))
        ;
    };
    return myFilterPredicate;
  }

  setDefaultLanguageString(language: String) {
    this.unitItemService.getActiveDatas().subscribe(data => {
      this.itemUnitList = data;
    });

  }

  getItemUnitListName(id: number) {
    return this.itemUnitList.find(p => p.itemUnitID === id).itemUnitName;
  }




  selectRow(selectedModel: tItemModelwithCateInfo, index: number) {

    this.log.i(this.TAG, 'do selectRow itemID = ' + selectedModel.itemID.toString() + ' , tableKeyValue = ' + this.tableKeyValue);

    const itemUnitStr = this.itemUnitList.find(p => p.itemUnitID === selectedModel.itemUnit).itemUnitName;

    this.log.i(this.TAG, itemUnitStr);

    this.selectedRowIndex = index;


    switch (this.tableKeyValue) {
      case MastersKeyStringValue.TABLE_ItemCate:
        this.tItemService.shareSelected(selectedModel.itemID.toString(),
          selectedModel.itemDesc.toString(),
          itemUnitStr,
          selectedModel.standardPrice);
        break;
      case MastersKeyStringValue.TABLE_PriceBook:
        // this.tItemService.shareSelectedPriceBook(selectedModel);
        break;
      default:
        this.tItemService.shareSelected(selectedModel.itemID.toString(),
          selectedModel.itemDesc.toString(),
          itemUnitStr,
          selectedModel.standardPrice);
        break;

    }


    // this.tItemService.shareSelected(selectedModel.itemID.toString(),
    //   selectedModel.itemDesc.toString(),
    //   itemUnitStr,
    //   selectedModel.standardPrice);



    this.activeModal.close(selectedModel);
  }




}
